import axios from 'axios'


const _options = {
  timeout: 7000,
  // 'http://10.10.152.115:55000' || process.env.VUE_APP_BASE_API
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://10.11.0.104:55000' : 'http://10.10.152.115:55000',
  // baseURL: 'http://10.11.0.104:55000',  //省公司环境 
  // baseURL: 'http://10.10.152.115:55000',  // 外事现场环境
  baseURL: '/api',  // 项目生产环境
  // baseURL:'http://www.ffasc.cn/api',
  showLoading: true,
  headers: {
    'Content-Type': 'application/json',
  },
}
let instance = axios.create(_options)
  
instance.interceptors.request.use(

  function (config) {
    // !config.headers['Authorization'] && (config.headers['Authorization'] = 'bearer '+ sessionStorage.getItem('token'))
    return config
  },

  function (error) {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    return response.data
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求出错'
          break
        case 401:
          err.message = '登陆超时'
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = '请求错误,未找到该资源'
          break
        case 500:
          err.message = '服务器端出错'
          break
        case 502:
          err.message = '服务器端出错'
          break
        case 'ECONNABORTED':
          err.message = '请求超时'
          break
      }
    } else {
      err.message = '连接服务器超时,请检查网络！'
    }
    return Promise.resolve(err.message)
  }
)

const http = function (methods, url, params, data, options) {
  return new Promise((resolve, reject) => {
    try {
      methods = methods.toLowerCase()
      instance[methods](url, Array.isArray(data) ? data : { ...params, ...data, ...options }).then(response => {
        if (typeof response === 'object') {
          if (typeof data === 'object') {
            response['params'] = { moduleCode: data.moduleCode };
          }
          return resolve(response)
        } else {
          return reject(response)
        }
      })
        .catch(e => {
          console.log(e)
          return reject(e)
        })
    } catch (e) {
      console.log(e)
    }
  })
}

export default http



// WEBPACK FOOTER //
// ./src/util/httpConfig.js